module.exports = __webpack_public_path__ + "img/btn-personal-info-th.6a89e045.png";